import { GameProvider } from '~/configs/enums/game'

export const LOTTERY_ITEMS = [
  {
    id: 'north',
    name: 'Miền Bắc',
    time: '18:15:00',
    class: 'b'
  },
  {
    id: 'central',
    name: 'Miền Trung',
    time: '17:15:00',
    class: 'box-area--blue'
  },
  {
    id: 'southern',
    name: 'Miền Nam',
    time: '16:15:00',
    class: 'box-area--purple'
  }
]

export const LODE_TABS = [
  {
    key: 'normal',
    label: 'Dò đầy đủ',
    value: 0
  },
  {
    key: 'twoNumbers',
    label: 'Dò 2 Số',
    value: 2
  },
  {
    key: 'threeNumbers',
    label: 'Dò 3 Số',
    value: 3
  }
]

export const PROVIDERS = {
  [GameProvider.B52]: {
    label: 'B52',
    icon: '/assets/images/icons/provider/b52.webp',
    iconGray: '/assets/images/icons/provider/b52-gray.webp',
    value: GameProvider.B52
  },
  [GameProvider.CQ9]: {
    label: 'CQ9',
    icon: '/assets/images/icons/provider/cq9.webp',
    iconGray: '/assets/images/icons/provider/cq9-gray.webp',
    value: GameProvider.CQ9
  },
  [GameProvider.EVOPLAY]: {
    label: 'Evoplay',
    icon: '/assets/images/icons/provider/evoplay.webp',
    iconGray: '/assets/images/icons/provider/evoplay-gray.webp',
    value: GameProvider.EVOPLAY
  },
  [GameProvider.HABANERO]: {
    label: 'Habanero',
    icon: '/assets/images/icons/provider/habanero.webp',
    iconGray: '/assets/images/icons/provider/habanero-gray.webp',
    value: GameProvider.HABANERO
  },
  [GameProvider.HIT_CLUB]: {
    label: 'HitClub',
    icon: '/assets/images/icons/provider/hitclub.webp',
    iconGray: '/assets/images/icons/provider/hitclub-gray.webp',
    value: GameProvider.HIT_CLUB
  },
  [GameProvider.JDB]: {
    label: 'JDB',
    icon: '/assets/images/icons/provider/jdb.webp',
    iconGray: '/assets/images/icons/provider/jdb-gray.webp',
    value: GameProvider.JDB
  },
  [GameProvider.NETENT]: {
    label: 'Netent',
    icon: '/assets/images/icons/provider/netent.webp',
    iconGray: '/assets/images/icons/provider/netent-gray.webp',
    value: GameProvider.NETENT
  },
  [GameProvider.PG_SOFT]: {
    label: 'PGSoft',
    icon: '/assets/images/icons/provider/pgsoft.webp',
    iconGray: '/assets/images/icons/provider/pgsoft-gray.webp',
    value: GameProvider.PG_SOFT
  },
  [GameProvider.PRAGMATIC]: {
    label: 'Pragmatic',
    icon: '/assets/images/icons/provider/pragmatic.webp',
    iconGray: '/assets/images/icons/provider/pragmatic-gray.webp',
    value: GameProvider.PRAGMATIC
  },
  [GameProvider.Q_TECH]: {
    label: 'QTech',
    icon: '/assets/images/icons/provider/qtech.webp',
    iconGray: '/assets/images/icons/provider/qtech-gray.webp',
    value: GameProvider.Q_TECH
  },
  [GameProvider.RED_TIGER]: {
    label: 'Red Tiger',
    icon: '/assets/images/icons/provider/redtiger.webp',
    iconGray: '/assets/images/icons/provider/redtiger-gray.webp',
    value: GameProvider.RED_TIGER
  },
  [GameProvider.RIK_VIP]: {
    label: 'Rik.Vip',
    icon: '/assets/images/icons/provider/rikvip.webp',
    iconGray: '/assets/images/icons/provider/rikvip-gray.webp',
    value: GameProvider.RIK_VIP
  },
  [GameProvider.SABA]: {
    label: 'Saba',
    icon: '/assets/images/icons/provider/saba.webp',
    iconGray: '/assets/images/icons/provider/saba-gray.webp',
    value: GameProvider.SABA
  },
  [GameProvider.SPRIBE]: {
    label: 'Spribe',
    icon: '/assets/images/icons/provider/spribe.webp',
    iconGray: '/assets/images/icons/provider/spribe-gray.webp',
    value: GameProvider.SPRIBE
  },
  [GameProvider.TECHPLAY]: {
    label: 'TechPlay',
    icon: '/assets/images/icons/provider/techplay.webp',
    iconGray: '/assets/images/icons/provider/techplay-gray.webp',
    value: GameProvider.TECHPLAY
  },
}
